import React from 'react'
import Link from 'next/link'

import styles from './styles.module.scss'

export const view = () => (
	<main className={styles.main}>
		<h1 className={styles.title}>Помощь</h1>
		<section>
			<h4 className={styles.heading}>Заёмщикам</h4>
			<ul className={styles.list}>
				<li>
					<Link href={'/faq/loans-cс'} className={styles.link}>
						Кредитование через Credit.Club
					</Link>
				</li>
				<li>
					<Link href={'/faq/about-сс'} className={styles.link}>
						О компании Credit.Club
					</Link>
				</li>
				<li>
					<Link href={'/faq/loan-conditions'} className={styles.link}>
						Условия получения кредита
					</Link>
				</li>
				<li>
					<Link href={'/faq/contract-and-money'} className={styles.link}>
						Подписание документов и поступление денег на счёт
					</Link>
				</li>
				<li>
					<Link href={'/faq/loan-repayments'}>Оплата и погашение кредита</Link>
				</li>
			</ul>
		</section>

		<section>
			<h4 className={styles.heading}>Инвесторам</h4>
			<ul>
				<li>
					<Link href={'/faq/invest-cс'} className={styles.link}>
						Сбережения в Credit.Club
					</Link>
				</li>
				<li>
					<Link href={'/faq/company-сс'} className={styles.link}>
						О компании и акционерах
					</Link>
				</li>
				<li>
					<Link href={'/faq/safety'} className={styles.link}>
						Надёжность сбережений
					</Link>
				</li>
				<li>
					<Link href={'/faq/contract-and-deposit'} className={styles.link}>
						Подписание документов и перевод денег
					</Link>
				</li>
				<li>
					<Link href={'/faq/actions'} className={styles.link}>
						Работа со сбережением
					</Link>
				</li>
			</ul>
		</section>
	</main>
)
